module.exports = __webpack_public_path__ + "img/logo-nano.66aab1ad.svg";